module.exports = __webpack_public_path__ + "img/card4.535a7f91.png";